import { Box, CircularProgress, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { WorkgroupMember } from "../../../../../modules/company/admin/organization/workgroups/workgroupsTypes"
import { LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    loader: {
        display: "flex",
        justifyContent: "center",
        padding: ".25rem",
    },
    memberList: {
        margin: 0,
        paddingLeft: "1rem",
    },
}))

type WorkgroupMembersTooltipProps = Readonly<{
    isLoading: boolean
    isError: boolean
    isAccessDenied: boolean
    members: ReadonlyArray<WorkgroupMember>
}>

export function WorkgroupMembersTooltip({ isLoading, isError, isAccessDenied, members }: WorkgroupMembersTooltipProps) {
    const { classes } = useStyles()

    if (isLoading) {
        return (
            <Box className={classes.loader}>
                <CircularProgress size={16} color="inherit" />
            </Box>
        )
    }

    if (isAccessDenied) {
        return (
            <LocalizedStrict id="confirm-order-dialog-workgroup-members-no-access">
                <Typography variant="body2">You do not have access to view group members</Typography>
            </LocalizedStrict>
        )
    }

    if (isError) {
        return (
            <LocalizedStrict id="confirm-order-dialog-workgroup-members-error">
                <Typography variant="body2">We cannot show the members right now</Typography>
            </LocalizedStrict>
        )
    }

    if (members.length === 0) {
        return (
            <LocalizedStrict id="confirm-order-dialog-workgroup-members-empty">
                <Typography variant="body2">No members to show</Typography>
            </LocalizedStrict>
        )
    }

    return (
        <Stack gap=".25rem">
            <LocalizedStrict id="confirm-order-dialog-workgroup-members-title">
                <Typography variant="subtitle2">Workgroup members</Typography>
            </LocalizedStrict>
            <Typography variant="body2" component="ul" className={classes.memberList}>
                {members.map((member) => (
                    <li key={member.id}>{member.displayName}</li>
                ))}
            </Typography>
        </Stack>
    )
}
